import css from 'styled-jsx/css'
import Modal from '../../../components/modal'

// ----------------------------------------------------------------------
const styles = css`
  .wrapper {
    max-width: 100vw;
    width: 43.6rem;
    padding: 2.8rem 2rem 4.8rem;
    background: #fff;
    border-radius: 1rem;

    h3 {
      font-size: 3.6rem;
    }

    p {
      margin: 2.2rem 0;
      line-height: 2rem;
      font-size: 1.6rem;
    }
  }
`
// ----------------------------------------------------------------------

export default function ConfirmationModal({ onClose }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <h3>Thank You</h3>
        <p>Your request form has been sent</p>
      </div>

      <style jsx>{styles}</style>
    </Modal>
  )
}
